import Pqp from "../../../3x1010/Pqp.js";

export default class Anim {
	constructor(sp, animationDefinition) {
		this.sp = sp;
		this.id = animationDefinition.id;
		this.sheet = animationDefinition.sheet;
		this.animationDefinition = animationDefinition;
		this.flip = animationDefinition.flip;
		this.frames = new Array();
	}

	init() {
		let a = this.animationDefinition.frames;
		for (let x = 0; x < a.length; x++) {
			if (!Pqp.isNullOrEmpty(a[x].goto)){
				this.frames.push({ goto: a[x].goto });
			} else {
				this.frames.push({ sprite: this.sp.getSprite(this.sheet, a[x].row, a[x].col), time: a[x].time });
			}
		}
	}
}